var map = {
	"./App": 7444,
	"./App.vue": 7444,
	"./assets/css/color.css": 9574,
	"./assets/css/style.css": 5549,
	"./assets/css/var/meraki.css": 4021,
	"./assets/icons/blood_pressure.svg": 6891,
	"./assets/icons/bmi.svg": 3873,
	"./assets/icons/height.svg": 2910,
	"./assets/icons/pulse.svg": 8274,
	"./assets/icons/temperature.svg": 2155,
	"./assets/icons/weight.svg": 3245,
	"./assets/images/card.png": 4020,
	"./assets/images/credit-card.png": 6358,
	"./assets/images/dolphinlogo.png": 3098,
	"./assets/images/eSewa-logo.png": 1326,
	"./assets/images/esewa.png": 7284,
	"./assets/images/esewa_logo.png": 7705,
	"./assets/images/esewa_min.png": 7560,
	"./assets/images/illustrations/deal.svg": 2246,
	"./assets/images/illustrations/doctor.svg": 6143,
	"./assets/images/illustrations/information.png": 4099,
	"./assets/images/illustrations/lab.svg": 3053,
	"./assets/images/illustrations/meds.svg": 8464,
	"./assets/images/illustrations/meds1.svg": 7991,
	"./assets/images/illustrations/meds2.svg": 1447,
	"./assets/images/illustrations/nursing_care.svg": 343,
	"./assets/images/illustrations/physiotherapy.svg": 2518,
	"./assets/images/illustrations/tele.svg": 8716,
	"./assets/images/illustrations/undraw_reminder_re_fe15.svg": 1935,
	"./assets/images/illustrations/vaccination.svg": 2051,
	"./assets/images/illustrations/visit.svg": 7476,
	"./assets/images/ime-main.svg": 2501,
	"./assets/images/khalti-logo.svg": 3581,
	"./assets/images/khalti_min.png": 1917,
	"./assets/images/logo.png": 4427,
	"./assets/images/logoContactUs.png": 5190,
	"./assets/images/mavorion.png": 6133,
	"./assets/images/meraki _min.png": 1908,
	"./assets/images/meraki.png": 4261,
	"./assets/images/qr.jpg": 2230,
	"./assets/images/user.png": 4353,
	"./components/accountSidenav": 5109,
	"./components/accountSidenav.vue": 5109,
	"./components/card/profile": 8757,
	"./components/card/profile.vue": 8757,
	"./components/common/modal": 2476,
	"./components/common/modal.vue": 2476,
	"./components/loaders/spinnerloader": 9955,
	"./components/loaders/spinnerloader.vue": 9955,
	"./components/modal/address": 7680,
	"./components/modal/address.vue": 7680,
	"./components/modal/addtocart": 2931,
	"./components/modal/addtocart.vue": 2931,
	"./components/modal/commment": 4158,
	"./components/modal/commment.vue": 4158,
	"./components/modal/confirmdelete": 9747,
	"./components/modal/confirmdelete.vue": 9747,
	"./components/modal/confirmdeletereport": 9283,
	"./components/modal/confirmdeletereport.vue": 9283,
	"./components/modal/deleteaddress": 9527,
	"./components/modal/deleteaddress.vue": 9527,
	"./components/modal/escortingaddress": 2614,
	"./components/modal/escortingaddress.vue": 2614,
	"./components/modal/orderdetails": 4989,
	"./components/modal/orderdetails.vue": 4989,
	"./components/modal/paymentInfo": 6939,
	"./components/modal/paymentInfo.vue": 6939,
	"./components/modal/paymentsure": 4613,
	"./components/modal/paymentsure.vue": 4613,
	"./components/modal/pdfView": 6619,
	"./components/modal/pdfView.vue": 6619,
	"./components/modal/proceedorder": 3587,
	"./components/modal/proceedorder.vue": 3587,
	"./components/modal/purchaseDetail": 9389,
	"./components/modal/purchaseDetail.vue": 9389,
	"./components/modal/uploaddoc": 2377,
	"./components/modal/uploaddoc.vue": 2377,
	"./components/norecord": 6345,
	"./components/norecord.vue": 6345,
	"./components/reportscomponent": 7137,
	"./components/reportscomponent.vue": 7137,
	"./components/tablist": 2040,
	"./components/tablist.vue": 2040,
	"./core/modules/address": 6693,
	"./core/modules/address.js": 6693,
	"./core/modules/auth/activate": 4082,
	"./core/modules/auth/activate.js": 4082,
	"./core/modules/auth/forgotpassword": 4090,
	"./core/modules/auth/forgotpassword.js": 4090,
	"./core/modules/auth/login": 5802,
	"./core/modules/auth/login.js": 5802,
	"./core/modules/auth/user": 6004,
	"./core/modules/auth/user.js": 6004,
	"./core/modules/common": 4889,
	"./core/modules/common.js": 4889,
	"./core/modules/components/card/profile": 6771,
	"./core/modules/components/card/profile.js": 6771,
	"./core/modules/header": 1220,
	"./core/modules/header.js": 1220,
	"./core/modules/landing": 492,
	"./core/modules/landing.js": 492,
	"./core/modules/manage/account": 4283,
	"./core/modules/manage/account.js": 4283,
	"./core/modules/manage/changepassword": 6076,
	"./core/modules/manage/changepassword.js": 6076,
	"./core/modules/manage/selectaccount": 1643,
	"./core/modules/manage/selectaccount.js": 1643,
	"./core/modules/payment/payment": 2735,
	"./core/modules/payment/payment.js": 2735,
	"./core/modules/purchase/purchaseHistory": 2949,
	"./core/modules/purchase/purchaseHistory.js": 2949,
	"./core/modules/reports/reports": 934,
	"./core/modules/reports/reports.js": 934,
	"./core/modules/self/allservices": 4489,
	"./core/modules/self/allservices.js": 4489,
	"./core/modules/self/contactUs": 7103,
	"./core/modules/self/contactUs.js": 7103,
	"./core/modules/self/forms": 4411,
	"./core/modules/self/forms.js": 4411,
	"./core/modules/self/mycart": 9566,
	"./core/modules/self/mycart.js": 9566,
	"./core/modules/self/mypurchase": 9766,
	"./core/modules/self/mypurchase.js": 9766,
	"./core/modules/self/order": 1986,
	"./core/modules/self/order.js": 1986,
	"./core/modules/self/services": 3501,
	"./core/modules/self/services.js": 3501,
	"./core/services/apiheader": 7409,
	"./core/services/apiheader.js": 7409,
	"./core/services/config": 2957,
	"./core/services/config.js": 2957,
	"./core/services/jwt": 850,
	"./core/services/jwt.js": 850,
	"./includes/footer": 5403,
	"./includes/footer.vue": 5403,
	"./includes/headerNew": 3327,
	"./includes/headerNew.vue": 3327,
	"./main": 2225,
	"./main.js": 2225,
	"./pages/Landing": 2115,
	"./pages/Landing.vue": 2115,
	"./pages/aboutus/contactUs": 2424,
	"./pages/aboutus/contactUs.vue": 2424,
	"./pages/aboutus/privacy": 8436,
	"./pages/aboutus/privacy.vue": 8436,
	"./pages/auth/Login": 5593,
	"./pages/auth/Login.vue": 5593,
	"./pages/auth/Otp": 7185,
	"./pages/auth/Otp.vue": 7185,
	"./pages/auth/Register": 2584,
	"./pages/auth/Register.vue": 2584,
	"./pages/auth/ResetPassword": 4939,
	"./pages/auth/ResetPassword.vue": 4939,
	"./pages/auth/activateAccount": 4606,
	"./pages/auth/activateAccount.vue": 4606,
	"./pages/auth/activatePassword": 3645,
	"./pages/auth/activatePassword.vue": 3645,
	"./pages/auth/forgotPassword": 3309,
	"./pages/auth/forgotPassword.vue": 3309,
	"./pages/manage/changepassword": 6546,
	"./pages/manage/changepassword.vue": 6546,
	"./pages/manage/myaccount": 8917,
	"./pages/manage/myaccount.vue": 8917,
	"./pages/manage/selectaccount": 1892,
	"./pages/manage/selectaccount.vue": 1892,
	"./pages/manage/updateaccount": 3983,
	"./pages/manage/updateaccount.vue": 3983,
	"./pages/paymentresponse": 5473,
	"./pages/paymentresponse-success": 2871,
	"./pages/paymentresponse-success.vue": 2871,
	"./pages/paymentresponse.vue": 5473,
	"./pages/reports/advices": 1511,
	"./pages/reports/advices.vue": 1511,
	"./pages/reports/investigation": 2058,
	"./pages/reports/investigation.vue": 2058,
	"./pages/reports/opdPrescription": 6954,
	"./pages/reports/opdPrescription.vue": 6954,
	"./pages/reports/prescription": 4331,
	"./pages/reports/prescription.vue": 4331,
	"./pages/reports/vitals": 3861,
	"./pages/reports/vitals.vue": 3861,
	"./pages/self/allservices": 4604,
	"./pages/self/allservices.vue": 4604,
	"./pages/self/checkout": 6977,
	"./pages/self/checkout.vue": 6977,
	"./pages/self/checkoutNew": 7767,
	"./pages/self/checkoutNew.vue": 7767,
	"./pages/self/forms": 8212,
	"./pages/self/forms.vue": 8212,
	"./pages/self/mycart": 5204,
	"./pages/self/mycart.vue": 5204,
	"./pages/self/myorders": 7055,
	"./pages/self/myorders.vue": 7055,
	"./pages/self/mypurchase": 7743,
	"./pages/self/mypurchase.vue": 7743,
	"./pages/self/myreports": 85,
	"./pages/self/myreports.vue": 85,
	"./router": 3413,
	"./router/": 3413,
	"./router/index": 3413,
	"./router/index.js": 3413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;